<template>
    <div id="home">
        <el-container>
            <!-- v-if="$route.path !== '/coin/paytran'" -->
            <el-header class="header" :height="'50px'" style="background: #040637; padding-right: 0px">
                <div class="logo">
                    <img src="./../assets/Logo_white.svg" alt />
                </div>
                <div class="nav">
                    <ul>
                        <li v-for="item in routes" @click="enter(item)" v-if="item.functionCategoryCode !== pub.routeNameLists.Message && item.functionCategoryCode !== pub.routeNameLists.Personal && item.functionCategoryCode !== pub.routeNameLists.HelpCenter" :class="{ active: $route.meta.activeMainMenu && $route.meta.activeMainMenu === item.functionCategoryCode }" :key="item.functionCategoryCode">
                            <!-- <div class="ch-route-nav-item" :id="item.functionCategoryCode" v-if="item.functionCategoryCode === 'Coin'">{{ isUsedDiamond ? '金幣/鑽石管理' : item.functionCategoryName }}</div> -->
                            <div class="ch-route-nav-item" :id="item.functionCategoryCode" v-if="item.functionCategoryCode === 'Coin'">{{ titleText }}</div>
                            <div class="ch-route-nav-item" :id="item.functionCategoryCode" v-else>{{ item.functionCategoryName }}</div>
                        </li>
                    </ul>
                </div>
                <div class="user" v-if="JSON.stringify(this.userInfo) !== '{}'">
                    <div>
                        <svg class="icon" aria-hidden="true" style="cursor: pointer; transform: scale(0.6)" @click="gotoDowloadApp">
                            <use xlink:href="#iconphone" />
                        </svg>
                    </div>
                    <div class="app-download" @click="gotoDowloadApp">App下載</div>
                    <router-link to="/cmessage/index" v-if="permissions.Message_Message_Examine">
                        <div class="message guide-message">
                            <svg class="icon" aria-hidden="true" style="transform: scale(0.85)">
                                <use :xlink:href="messageHaveRead ? '#iconxiaoxi1' : '#iconxiaoxi2'" />
                            </svg>
                        </div>
                        <div class="notice">通知</div>
                    </router-link>
                    <!-- ---------------头像部分-------------- -->
                    <div>
                        <el-dropdown trigger="hover" @command="handleCommand">
                            <div class="avatar-wrapper">
                                <div class="user-img">
                                    <el-image :src="userImg" :lazy="lazyLoadingAva" class="ch-image" fit="fill" :key="userImg"></el-image>
                                </div>
                                <div class="username">{{ userInfo.name }}</div>
                                <svg class="icon" aria-hidden="true" style="transform: scale(0.5)">
                                    <use xlink:href="#iconzhankaigengduo" />
                                </svg>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="commands[0]" v-if="userInfo.roleList && userInfo.roleList.length > 1">
                                    <span class="dropdown-tab-text">切換賬戶</span>
                                </el-dropdown-item>
                                <el-dropdown-item :command="commands[1]">
                                    <span class="dropdown-tab-text">個人中心</span>
                                </el-dropdown-item>
                                <el-dropdown-item :command="commands[2]" v-if="companyType == 0">
                                    <span class="dropdown-tab-text">幫助中心</span>
                                </el-dropdown-item>
                                <el-dropdown-item :command="commands[3]">
                                    <span class="dropdown-tab-text">修改密碼</span>
                                </el-dropdown-item>
                                <el-dropdown-item :command="commands[4]">
                                    <span class="dropdown-tab-text">登出</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-header>
            <el-container class="container">
                <el-aside :width="sideBar ? '140px' : '60px'" class="aside" :class="sideBar ? 'chAsideShow' : 'chAsideHide'" style="padding-top: 5px; background: #090b3b" v-if="$route.meta.showTab">
                    <div :class="sideBar ? 'ch-hidden-nav' : 'ch-hidden-nav-h'">
                        <svg class="icon" aria-hidden="true" style="font-size: 16px; cursor: pointer; fill: #00ff00" v-if="!sideBar" @click="changeSideBar(true)">
                            <use xlink:href="#iconzhankaicebianlan" />
                        </svg>
                        <svg class="icon" aria-hidden="true" style="font-size: 16px; cursor: pointer; fill: #00ff00" v-else @click="changeSideBar(false)">
                            <use xlink:href="#iconshouqicebianlan" />
                        </svg>
                    </div>
                    <ul>
                        <template v-if="undefined !== nowPage && null !== nowPage">
                            <li @click="clickEnter(item)" v-for="item in routes[nowPage - 1].functionModules" :key="item.functionModuleCode" v-if="item.functionModuleCode !== pub.routeNameLists.RolePermission && routes[nowPage - 1].functionCategoryCode !== 'HelpCenter'">
                                <div class="ch-route-lv-item-box">
                                    <div :class="{ active: $route.meta.activeSubMenu === item.functionModuleCode, 'ch-route-lv-item': true }">
                                        <div class="ch-route-lv-item-flex">
                                            <span :class="$route.meta.activeSubMenu === item.functionModuleCode ? 'ch-route-lv-item-icon-active' : 'ch-route-lv-item-icon'">
                                                <svg class="icon" :class="{ 'active-icon': $route.meta.activeSubMenu === item.functionModuleCode, 'inactive-icon': $route.meta.activeSubMenu !== item.functionModuleCode }">
                                                    <use :xlink:href="item.icon" />
                                                </svg>
                                            </span>
                                            <!-- 砖石需求-金币管理menu -->
                                            <span :class="$route.meta.activeSubMenu === item.functionModuleCode ? 'ch-route-lv-item-text-active' : 'ch-route-lv-item-text'" v-if="sideBar && routes[nowPage - 1].functionCategoryCode === 'Coin'">
                                                <!-- {{ item.functionModuleCode === 'Coin_CoinManage' && isUsedDiamond ? '金幣/鑽石管理' : item.functionModuleCode === 'Coin_Record' && isUsedDiamond ? '金幣/鑽石記錄' : item.functionModuleName.substr(item.functionModuleName.indexOf('_') + 1, item.functionModuleName.length) }} -->
                                                <!-- {{ item.functionModuleCode === 'Coin_CoinManage' && isUsedDiamond ? '金幣/鑽石管理' : item.functionModuleCode === 'Coin_Record' && isUsedDiamond ? '金幣/鑽石記錄' : item.functionModuleName.substr(item.functionModuleName.indexOf('_') + 1, item.functionModuleName.length) }} -->
                                                {{ MenuDimCoin(item.functionModuleCode) }}
                                            </span>
                                            <span :class="$route.meta.activeSubMenu === item.functionModuleCode ? 'ch-route-lv-item-text-active' : 'ch-route-lv-item-text'" v-if="sideBar && routes[nowPage - 1].functionCategoryCode !== 'Coin'">
                                                {{item.functionModuleName.substr(item.functionModuleName.indexOf('_') + 1, item.functionModuleName.length) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <!-- 帮助中心 -->
                            <li v-if="sideBar && routes[nowPage - 1].functionCategoryCode == 'HelpCenter'">
                                <div class="ch-route-help-item-text">
                                    <div :class="['comQue', $store.state.selectLi == 0 ? 'catactive' : '']" @click="toHelpIndex">常見問題</div>
                                    <div v-for="(item, index) in categoryList" :key="item.categoryName">
                                        <!-- 有子菜单 -->
                                        <template v-if="item.childCategorys && item.childCategorys.length !== 0">
                                            <!-- 一级 -->
                                            <div :class="[$store.state.selectLi == item.categoryID ? 'catactive' : '', 'cate-flex']">
                                                <span @click="changeCate(item)">
                                                    {{ item.categoryNameWithCulture }}
                                                </span>
                                                <span v-if="!item.showChild" class="icon-down" @click="isshowChild(index, true)">
                                                    <i class="el-icon-arrow-down"></i>
                                                </span>
                                                <span v-if="item.showChild" class="icon-down" @click="isshowChild(index, false)">
                                                    <i class="el-icon-arrow-up"></i>
                                                </span>
                                            </div>
                                            <!-- 二级 -->
                                            <div v-if="item.showChild">
                                                <div @click="changeCate(child)" :class="[$store.state.selectLi == child.categoryID ? 'catactive' : '', 'child-cate']" v-for="child in item.childCategorys" :key="child.categoryNameWithCulture">
                                                    <span>{{ child.categoryNameWithCulture }}</span>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- 无子菜单 -->
                                        <template v-else>
                                            <div @click="changeCate(item)" :class="[$store.state.selectLi == item.categoryID ? 'catactive' : '', 'nochile-cate']">{{ item.categoryNameWithCulture }}</div>
                                        </template>
                                    </div>
                                </div>
                            </li>
                            <!-- <li v-if="sideBar && routes[nowPage - 1].functionCategoryCode == 'HelpCenter'">
                                <span class="ch-route-lv-item-text">
                                    <el-menu @close="handleClose" @open="handleOpen" @select="selectMenu" class="el-menu-vertical-demo" background-color="#060b3b" text-color="#fff" active-text-color="#ffd04b">
                                        <div v-for="item in categoryList" :key="item.categoryName">
                                            <el-submenu v-if="item.childCategorys" :index="item.categoryName">
                                                <template slot="title">
                                                    {{ item.categoryNameWithCulture }}
                                                </template>
                                                <template v-for="child in item.childCategorys">
                                                    <el-menu-item :key="child.categoryName" :index="child.categoryName">
                                                        {{ child.categoryNameWithCulture }}
                                                    </el-menu-item>
                                                </template>
                                            </el-submenu>
                                            <template v-else>
                                                <el-menu-item :index="item.categoryName">
                                                    {{ item.categoryNameWithCulture }}
                                                </el-menu-item>
                                            </template>
                                        </div>
                                    </el-menu>
                                </span>
                            </li> -->
                        </template>
                    </ul>
                </el-aside>
                <el-main>
                    <router-view name="default" />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import HomePage from './home_page/index';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: { HomePage },
    data() {
        return {
            showChild: false,
            categoryList: [],
            sortNotice: [],
            linkList: [],
            linkUrl: [],
            showAside: true,
            timer: null,
            needReadMessage: [],
            messageTimer: null,
            defaultAvatar: require('../assets/default-avatar.svg'),
            commands: ['changeOrganization', 'personalCenter', 'helpCenter', 'changePassword', 'logout'],
            lazyLoadingAva: true,
            isUsedDiamond: null, //是否开启砖石
            isUsedCoin: null,
            isUsePropertyDeal:false,
            titleText: '',
            companyType:0,
            messageType: '',
            flag: true, //消息提示跳转
            noticeflag: true,
            countMes: [], //关闭单个提示时的notify合集
            Dtime: '',
        };
    },
    async created() {
        if (this.$route.name == 'post' && this.$route.query.email) {
            return;
        }
        if (!this.userInfo.roleName || JSON.stringify(this.userInfo) === '{}') {
            await this.pub.obtainAndSetUserInfo();
        }
        if (JSON.stringify(this.routes) === '{}' || !this.routes[0].routeId) {
            if (this.userInfo.roleID !== null) {
                await this.pub.obtainAndSetRoutes(this.userInfo.roleID);
            }
        }
        if (JSON.stringify(this.permissions) === '{}') {
            if (this.userInfo.roleID !== null) {
                await this.pub.obtainAndSetPermissions(this.userInfo.roleID);
            }
        }

        if (this.$route.name === this.pub.routeNameLists.HomeBase) {
            this.$router.replace({ name: this.pub.routeNameLists.HomePage }).catch(err => {});
        }
        if (this.permissions.Message_Message_Examine) {
            this.getAllMessage();
            // 首先查询一下是否有未读消息
            this.getAllNotReadMessage();
            // 之后轮询查是否有未读消息
            this.startGetNotReadMessage();
            
        }
        this.setSideBar(true);
        this.getCompanyCofig();
        this.getcategorys();
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.messageTimer);
    },
    computed: {
        ...mapGetters(['userInfo', 'routes', 'sideBar', 'accessRoutePage', 'permissions', 'messageHaveRead']),
        userImg() {
            return this.userInfo.imagePath ? this.pub.imgResize(this.userInfo.imagePath, 'user') : this.defaultAvatar;
        },
        nowPage() {
            if (JSON.stringify(this.accessRoutePage) !== '{}') {
                return this.accessRoutePage[this.$route.name] ? this.accessRoutePage[this.$route.name].nowPage : this.accessRoutePage[this.$route.meta.activeMainMenu].nowPage;
            } else {
                return null;
            }
        },
        MenuDimCoin() {
            return function (ModuleCode) {
                if (ModuleCode === 'Coin_CoinManage') {
                    return this.isUsedDiamond && this.isUsedCoin ? '金幣/鑽石管理' : this.isUsedDiamond ? '鑽石管理' : '金幣管理';
                } else if (ModuleCode === 'Coin_Record') {
                    return this.isUsedDiamond && this.isUsedCoin ? '金幣/鑽石記錄' : this.isUsedDiamond ? '鑽石記錄' : '金幣記錄';
                }else if(ModuleCode === 'Coin_Coupon'){
                    return "優惠碼兌換"
                }
                // console.log(item, 'itemRole');
            };
        }
    },
    methods: {
        toHelpIndex() {
            this.$store.commit('changeSelectLi', 0);
            this.$router.push({ name: this.pub.routeNameLists.HelpIndex });
        },
        changeCate(item) {
            this.$store.commit('changeSelectLi', item.categoryID);
            // this.selectLi = item.categoryID
            this.$router.push({ path: '/helpcenter/asidelist', query: { categoryID: item.categoryID } });
            // this.$router.push({name: this.pub.routeNameLists.HelpCateList,params:{categoryID:item.categoryID}});
        },
        isshowChild(index, flag) {
            this.$set(this.categoryList[index],'showChild',flag)
            this.$forceUpdate()
            this.showChild = !this.showChild;
        },
        getcategorys() {
            this.axios.get(this.pub.getApi().GetCategorys).then(res => {
                // console.log(res,'配置');
                if (res.data.code === 0 && res.data.result) {
                    this.categoryList = res.data.result;
                    this.categoryList.forEach((it, index) => {
                        it['showChild'] = false;
                    });
                }
            });
        },
        // 获取公司配置
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                // console.log(res,'配置');
                if (res.data.code === 0 && res.data.result) {
                    // 1 中原，2 利嘉阁 3 其他公司
                    this.isUsedDiamond = res.data.result.isUsedDiamond;
                    this.isUsedCoin = res.data.result.isUsedCoin;
                    this.isShowDiamondHistory = res.data.result.isShowDiamondHistory;
                    this.isUsePropertyDeal = res.data.result.isUsePropertyDeal
                    this.titleText = this.isUsedDiamond && this.isUsedCoin ? '金幣/鑽石管理' : this.isUsedDiamond ? '鑽石管理' : '金幣管理';
                    this.isUseCoupon =  res.data.result.isUseCoupon
                    this.companyType = res.data.result.companyType
                }
                if(this.companyType != 2){
                    // 优惠券兑换
                    let couponExchange = {
                        functionCategoryID: 3,
                        functionModuleCode: "Coin_Coupon",
                        functionModuleName: "金幣管理_優惠碼兌換",
                        functionModuleNameEn: "",
                        icon: "#iconduihuanyouhuiquan1",
                        routeId: 3,
                        sequence: 3,
                        url: "/Coin/Coin_Coupon",
                    }
                    const couponName = 'Coin_Coupon';
                    for (let i = 0; i < this.routes.length; i++) {
                        // 判断当前存在金幣管理
                        if(this.routes[i].functionCategoryCode == 'Coin'){
                            // 找到 金币钻石记录的位置 永远在金币钻石记录中间
                            let targetFrontIndex = this.routes[i].functionModules.findIndex(item => item.functionModuleCode === 'Coin_Record');
                            let targetBehindIndex = this.routes[i].functionModules.findIndex(item => item.functionModuleCode === 'Coin_CoinManage');
                            // 判断有无 优惠券
                            const targetIndex = this.routes[i].functionModules.findIndex(item => item.functionModuleCode === couponName);
                            if (targetIndex > -1 && !this.isUseCoupon) {
                                this.routes[i].functionModules.splice(targetIndex, 1);
                            }else if(targetIndex == -1 && this.isUseCoupon){
                                if(targetFrontIndex !== -1 ){
                                    this.routes[i].functionModules.splice(targetFrontIndex,0, couponExchange)
                                }else if(targetBehindIndex !==-1){
                                    this.routes[i].functionModules.splice(targetBehindIndex+1,0, couponExchange)
                                }
                            }
                        }
                        
                    }
                }

                if(this.companyType == 0){
                    //成交数据 同后台权限绑定
                    let dealData={
                        functionCategoryID: 5,
                        functionModuleCode: "System_Deal",
                        functionModuleName: "業務設定_成交數據",
                        functionModuleNameEn: "",
                        icon: "#iconshuju2",
                        routeId: 5,
                        sequence: 5,
                        url: "/System/System_Deal",
                    }
                    const targetName = 'System_Deal';
                    for (let i = 0; i < this.routes.length; i++) {
                        if(this.routes[i].functionCategoryCode == 'System'){
                            const targetFrontIndex = this.routes[i].functionModules.findIndex(item => item.functionModuleCode === 'System_Branch');
                            const targetIndex = this.routes[i].functionModules.findIndex(item => item.functionModuleCode === targetName);
                            if (targetIndex > -1 && !this.isUsePropertyDeal) {
                                this.routes[i].functionModules.splice(targetIndex, 1);
                            }else if(targetIndex == -1 && this.isUsePropertyDeal){
                                this.routes[i].functionModules.splice(targetFrontIndex+1,0, dealData)
                            }
                        }
                    }
                }            
            });
        },
        ...mapActions(['setPage', 'setSideBar', 'resetVuex', 'setMessageHaveRead', '']),
        changeSideBar(value) {
            this.setSideBar(value);
        },
        startGetNotReadMessage() {
            this.messageTimer = setInterval(this.getAllMessage, 10000);
            this.timer = setInterval(this.getAllNotReadMessage, 10000);
        },
        // 对消息数据进行排序，最后面的信息第一个展示
        compare(prop) {
            return function (obj1, obj2) {
                var val1 = obj1[prop];
                var val2 = obj2[prop];
                if (val1 > val2) {
                    return 1;
                } else if (val1 < val2) {
                    return -1;
                } else {
                    return 0;
                }
            };
        },

        timestampToTime(cjsj) {
            let date = new Date(cjsj * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = '/' + date.getFullYear();
            let M = '/' + (date.getMonth() + 1);
            let D = date.getDate();
            this.Dtime = D + M + Y;
        },
        async getAllMessage() {
            let _this = this;
            let notReadMessage = await this.axios.post(this.pub.getApi().GetAllMessage);
            if (notReadMessage && notReadMessage.data) {
                this.sortNotice = notReadMessage.data.result;
                // 后天数据倒序展示
                this.sortNotice.sort(this.compare('createTime'));
                this.needReadMessage = this.sortNotice;
                if (this.needReadMessage.length <= 10) {
                    // this.noticeflag = true
                    this.needReadMessage.forEach((item, index) => {
                        this.noticeflag = false;
                        const h = this.$createElement;
                        if (item.messageType == 3 && (item.messageUrl || item.sysMessageTypeWithCluture == '【新盤速遞】')) {
                            let notify = this.$notify({
                                title: item.messageTypeWithCluture,
                                customClass: 'shishi',
                                message: h('p', null, [
                                    h('span', null, item.messageContent),
                                    h(
                                        'a',
                                        {
                                            style: {
                                                display: 'block',
                                                cursor: 'pointer',
                                                color: 'blue',
                                                position: 'absolute',
                                                right: '29px',
                                                bottom: '3px'
                                            },
                                            // on: {
                                            //     click: this.clickBtn
                                            // }
                                            on: {
                                                click: () => {
                                                    this.clickBtn(item, notify._uid);
                                                }
                                            }
                                        },
                                        '查看'
                                    ),
                                    h(
                                        'a',
                                        {
                                            style: {
                                                display: 'block',
                                                cursor: 'pointer',
                                                color: 'blue',
                                                position: 'absolute',
                                                right: '69px',
                                                bottom: '3px'
                                            },
                                            on: {
                                                click: this.clickClose
                                            }
                                        },
                                        '關閉全部'
                                    )
                                ]),
                                // onClick() {
                                //     _this.mesClick(item); //自定义回调,message为传的参数
                                // },
                                onClose() {
                                    _this.closeOne();
                                },
                                offset: 0,
                                duration: 0
                            });
                            if (notify) {
                                this.countMes.push(notify);
                            }
                        } else if (item.messageType == 0 && (item.sourceType == 'RemindRecommManySingle' || item.sourceType == 'RemindRecommendManySource')) {
                            // 需求要求置顶信息需要显示在第二行 可通过修改类名
                            // let className = '';
                            // if(this.needReadMessage.length>1) {
                            //     className = 'shishia'
                            // }else{
                            //     className = 'shishi'
                            // }
                            this.timestampToTime(item.createTime);
                            if (item.sourceType == 'RemindRecommManySingle') {
                                let notify = this.$notify({
                                    title: item.messageTypeWithCluture,
                                    customClass: 'shishi',
                                    message: h('p', null, [
                                        // item.messageContent
                                        h('span', null, `${item.messageContent}(${this.Dtime})`),
                                        h(
                                            'a',
                                            {
                                                style: {
                                                    display: 'block',
                                                    cursor: 'pointer',
                                                    color: 'blue',
                                                    position: 'absolute',
                                                    right: '9px',
                                                    bottom: '3px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.clickBtn(item, notify._uid);
                                                    }
                                                }
                                            },
                                            '點擊推前'
                                        ),
                                        h(
                                            'a',
                                            {
                                                style: {
                                                    display: 'block',
                                                    cursor: 'pointer',
                                                    color: 'blue',
                                                    position: 'absolute',
                                                    right: '77px',
                                                    bottom: '3px'
                                                },
                                                on: {
                                                    click: this.clickClose
                                                }
                                            },
                                            '關閉全部'
                                        )
                                    ]),
                                    onClose() {
                                        _this.closeOne();
                                    },
                                    offset: 0,
                                    duration: 0
                                });
                                if (notify) {
                                    this.countMes.push(notify);
                                }
                            } else {
                                this.timestampToTime(item.createTime);
                                let notify = this.$notify({
                                    title: item.messageTypeWithCluture,
                                    customClass: 'shishi',
                                    message: h('p', null, [
                                        h('span', null, `${item.messageContent}(${this.Dtime})`),
                                        h(
                                            'a',
                                            {
                                                style: {
                                                    display: 'block',
                                                    cursor: 'pointer',
                                                    color: 'blue',
                                                    position: 'absolute',
                                                    right: '9px',
                                                    bottom: '3px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.clickBtn(item, notify._uid);
                                                    }
                                                }
                                            },
                                            '點擊推前'
                                        ),
                                        h(
                                            'a',
                                            {
                                                style: {
                                                    display: 'block',
                                                    cursor: 'pointer',
                                                    color: 'blue',
                                                    position: 'absolute',
                                                    right: '77px',
                                                    bottom: '3px'
                                                },
                                                on: {
                                                    click: this.clickClose
                                                }
                                            },
                                            '關閉全部'
                                        )
                                    ]),
                                    onClose() {
                                        _this.closeOne();
                                    },
                                    offset: 0,
                                    duration: 0
                                });
                                if (notify) {
                                    this.countMes.push(notify);
                                }
                            }
                        } else {
                            // 没有链接的信息不显示‘查看’
                            this.$notify({
                                title: item.messageTypeWithCluture,
                                customClass: 'shishi',
                                message: h('p', null, [
                                    h('span', null, item.messageContent),
                                    h(
                                        'a',
                                        {
                                            style: {
                                                display: 'block',
                                                cursor: 'pointer',
                                                color: 'blue',
                                                position: 'absolute',
                                                right: '29px',
                                                bottom: '3px'
                                            },
                                            on: {
                                                click: this.clickClose
                                            }
                                        },
                                        '關閉全部'
                                    )
                                ]),
                                offset: 0,
                                duration: 0,
                                onClose() {
                                    _this.closeOne();
                                }
                            });
                        }
                    });
                }
                // 当信息多过于10时
                if (this.needReadMessage.length > 10) {
                    const h = this.$createElement;
                    this.$notify({
                        title: '未讀通知',
                        customClass: 'shishi',
                        message: h('p', null, [
                            h('span', null, `你有${this.needReadMessage.length}個未讀通知，立即點擊查看!`),
                            h(
                                'a',
                                {
                                    style: {
                                        display: 'block',
                                        cursor: 'pointer/*  */',
                                        color: 'blue',
                                        position: 'absolute',
                                        right: '29px',
                                        bottom: '3px'
                                    },
                                    on: {
                                        click: this.clickBtns
                                    }
                                },
                                '查看'
                            )
                        ]),
                        offset: 0,
                        duration: 0
                    });
                }
            }
        },
        clickClose() {
            this.$notify.closeAll();
        },
        closeOne() {
            this.noticeflag = true;
        },
        // mesClick(item) {
        //     this.messageUrl=''
        //     this.messageType = item.messageType;
        //     if (item.messageUrl) {
        //         this.messageUrl = item.messageUrl;
        //     }
        //     if (item.estateID) {
        //         this.estateID = item.estateID;
        //     }
        //     //点击空白处不能跳转
        //     //点击查看 要等mesclick执行结束再次进行clickbtn 多次点击会出现问题
        //     if (!this.flag) {
        //         this.clickBtn();
        //         this.flag = true;
        //     }
        // },
        clickBtns() {
            this.$router.push('/cmessage/index');
            this.$notify.closeAll();
        },
        clickBtn(item, count) {
            if (item.sourceType == 'RemindRecommManySingle') {
                //置顶楼盘含单条消息跳转首页 多条跳转消息中心
                // 重新置顶
                // console.log('this.$routerbbbbbbbb', this.$route);
                if (this.$route.name != 'Property_PropertyManage') {
                    this.$router.push({
                        name: this.pub.routeNameLists.PropertyIndex,
                        params: {
                            keystring: item.sourceID
                        }
                    });
                } else {
                    // 本页跳转本页有问题！！
                    // this.$route.params.keyString=item.sourceID
                    // this.$router.push('/property/index')
                    // this.$router.go(0)
                    this.$store.commit('changeKeyString', item.sourceID);
                }
            } else {
                this.$router.push('/cmessage/index');
            }
            this.messageUrl = '';
            this.messageType = item.messageType;
            if (item.messageUrl) {
                this.messageUrl = item.messageUrl;
            }
            if (item.estateID) {
                this.estateID = item.estateID;
            }
            // this.flag = false;
            if (this.messageType == 3 && this.needReadMessage.length <= 10) {
                if (this.estateID > 0) {
                    const license = this.userInfo.accountID ? 'A' + this.userInfo.accountID : 'none';
                    window.open(`${this.pub.config.wapUrl}new-property-${this.estateID}.html?license=${license}`, '_blank');
                    this.messageUrl = '';
                    this.estateID = '';
                } else if (this.messageUrl) {
                    var url = this.messageUrl;
                    if (this.messageUrl.indexOf('http') == -1) {
                        url = '//' + url;
                    }
                    window.open(url, '_blank');
                    this.messageUrl = '';
                }
            }
            for (let i = 0; i < this.countMes.length; i++) {
                if (this.countMes[i]._uid == count) {
                    this.countMes[i].close();
                    this.countMes.splice(i, 1);
                }
            }
        },
        async getAllNotReadMessage() {
            let messages = await this.axios.get(this.pub.getApi().GetUserMessage);
            let notReadCount = 0;
            // console.log("messages.data",messages,messages.data)
            if (messages.data.code !== 500) {
                if (messages && messages.data) {
                    for (let item of messages.data.result) {
                        // if (item.messageType !== 3) {
                        notReadCount += item.messageNoReadCount;
                        // }
                    }
                    if (notReadCount > 0) {
                        this.setMessageHaveRead(false);
                    } else {
                        this.setMessageHaveRead(true);
                    }
                }
            }
        },
        // 跳转到app下载页面
        gotoDowloadApp() {
            this;
            this.$router.push({ name: this.pub.routeNameLists.AppDownload }).catch(err => {});
        },
        handleCommand(command) {
            //0-选择组织 1-个人中心 2-修改密码 3-登出功能
            if (command === this.commands[0]) {
                this.$router.push({ name: this.pub.routeNameLists.SelectRole });
            } else if (command === this.commands[1]) {
                this.$router.push({ name: this.pub.routeNameLists.PersonalCenter });
            } else if (command === this.commands[2]) {
                this.$router.push({ name: this.pub.routeNameLists.HelpIndex });
                // let index = this.routes.findIndex(item => item.functionCategoryCode === this.pub.routeNameLists.HelpCenter);
                // this.enter(this.routes[index]);
            } else if (command === this.commands[3]) {
                this.$router.push({ name: this.pub.routeNameLists.ChangePassword });
            } else if (command === this.commands[4]) {
                this.logout();
            }
        },
        //登出系统功能
        logout() {
            this.$confirm('確認要登出本系統？', '登出', {
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$notify.closeAll();
                    let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
                    for (let i = 0; i < keys.length; i++) {
                        if(keys[i].indexOf('dEVaUDFrZ1kd0RA') != -1 ){
                            this.pub.delCookie(keys[i]);
                        }
                    }
                    // this.pub.delCookie('dEVaUDFrZ1kd0RA');
                    this.resetVuex();
                    this.$router.push({ name: this.pub.routeNameLists.Login }).catch(err => {
                        console.log(err);
                    });
                })
                .catch(() => {});
        },
        clickEnter(item) {
            this.$router.push({ name: item.functionModuleCode });
        },
        enter(data) {
            if (data.functionModules.length === 0) {
                this.$router.push({ name: data.functionCategoryCode }).catch(err => {});
            } else {
                this.$router.push({ name: data.functionModules[0].functionModuleCode }).catch(err => {});
            }
        }
    }
};
</script>

<style lang="less">
.shishi {
    position: absolute;
    top: 53px !important;
    right: 10px !important;
    height: 108px;
    width: 335px;
    span {
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
}
.messageBox_class {
    position: absolute;
    width: 389px;
    height: 150px;
    top: 53px;
    right: 0;
    background-color: #ffffff;
}
.chAsideShow {
    transform: translateX();
    transition-duration: 1s;
    -webkit-transform: translateX();
    -webkit-animation-duration: 1s;
    -moz-transform: translateX();
    -webkit-transform-duration: 1s;
}

.chAsideHide {
    transform: translateX();
    transition-duration: 1s;
    -webkit-transform: translateX();
    -webkit-animation-duration: 1s;
    -moz-transform: translateX();
    -webkit-transform-duration: 1s;
}

.user {
    line-height: 50px;
    float: right;

    div {
        float: left;
    }

    .app-download {
        line-height: 50px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        margin-left: -15px;
        margin-right: 15px;
        cursor: pointer;
    }

    .message {
        svg {
            font-size: 24px;
            line-height: 50px;
        }
    }
    .notice {
        line-height: 50px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        margin-left: -7px;
        margin-right: 15px;
        cursor: pointer;
    }

    .avatar-wrapper {
        cursor: pointer;
        height: 50px;
        margin-left: -10px;
        margin-right: -10px;
    }

    .user-img {
        margin-left: 5px;
        position: relative;
        top: 11px;
        width: 28px;
        height: 28px;
        border-radius: 14px;
        overflow: hidden;

        .ch-image {
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
            background-color: #eee;
        }
    }

    .username {
        line-height: 50px;
        font-size: 18px;
        color: #ffffff;
        // max-width: 130px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-left: 10px;
    }

    .icon {
        color: #ffffff;
        height: 50px;
        width: 45px;
        line-height: 50px;
    }
}

html,
body,
#home,
.el-container {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;

    @media screen and(min-width: 1420px) {
        .header {
            padding-left: 15px;

            .logo {
                width: 120px;
                float: left;

                img {
                    position: relative;
                    top: 15px;
                    height: 30px;
                    opacity: 0.6;
                }
            }

            .nav {
                float: left;
                margin-left: 20px;

                ul,
                li {
                    padding: 0;
                    margin: 0;
                    height: 50px;
                    list-style: none;
                    margin-left: 50px;
                }

                li {
                    float: left;
                    line-height: 50px;
                    font-size: 15px;
                    font-weight: bold;
                    box-sizing: border-box;
                    cursor: pointer;

                    .ch-route-nav-item {
                        display: block;
                        padding: 0 10px;
                        height: 50px;
                        line-height: 50px;
                        text-decoration: none;
                        color: #999999;
                        cursor: pointer;
                    }
                }

                .active {
                    border-bottom: 4px solid #e50113;
                }

                .active .ch-route-nav-item {
                    color: #ffffff;
                }
            }
        }
    }
    @media screen and(max-width: 1420px) and (min-width: 1280px) {
        .header {
            padding-left: 15px;

            .logo {
                width: 120px;
                float: left;

                img {
                    position: relative;
                    top: 15px;
                    opacity: 0.6;
                    height: 30px;
                }
            }

            .nav {
                float: left;
                margin-left: 20px;

                ul,
                li {
                    padding: 0;
                    margin: 0;
                    height: 50px;
                    list-style: none;
                    margin-left: 25px;
                }

                li {
                    float: left;
                    line-height: 50px;
                    font-size: 15px;
                    font-weight: bold;
                    box-sizing: border-box;
                    cursor: pointer;

                    .ch-route-nav-item {
                        display: block;
                        padding: 0 10px;
                        height: 50px;
                        line-height: 50px;
                        text-decoration: none;
                        color: #999999;
                        cursor: pointer;
                    }
                }

                .active {
                    border-bottom: 4px solid #e50113;
                }

                .active .ch-route-nav-item {
                    color: #ffffff;
                }
            }
        }
    }
    @media screen and(max-width: 1280px) {
        .header {
            padding-left: 15px;

            .logo {
                width: 120px;
                float: left;

                img {
                    position: relative;
                    top: 15px;
                    height: 30px;
                    opacity: 0.6;
                }
            }

            .nav {
                float: left;
                margin-left: 20px;

                ul,
                li {
                    padding: 0;
                    margin: 0;
                    height: 50px;
                    list-style: none;
                    margin-left: 20px;
                }

                li {
                    float: left;
                    line-height: 50px;
                    font-size: 15px;
                    font-weight: bold;
                    box-sizing: border-box;
                    cursor: pointer;

                    .ch-route-nav-item {
                        display: block;
                        padding: 0 10px;
                        height: 50px;
                        line-height: 50px;
                        text-decoration: none;
                        color: #999999;
                        cursor: pointer;
                    }
                }

                .active {
                    border-bottom: 4px solid #e50113;
                }

                .active .ch-route-nav-item {
                    color: #ffffff;
                }
            }
        }
    }
}

a {
    text-decoration: none;
}

.header {
    height: 50px;
    background: white;
    //border-bottom: solid 1px #dedee4;
}

.aside {
    background: white;
    height: 100%;
    text-align: left;

    ul,
    li {
        list-style: none;
        padding: 0;
        margin: 0;
        cursor: pointer;
        overflow: hidden;
    }
    .ch-route-help-item-text {
        margin-top: 14px;
        margin-bottom: 14px;
        font-weight: 400;
        div {
            padding-top: 10px;
            font-size: 14px;
            color: #fff;
            background-color: #060b3b;
        }
        .comQue {
            padding-left: 15px;
            height: 42px;
            line-height: 31px;
        }
        .catactive {
            background-color: #0062ff;
        }
        .child-cate {
            font-size: 12px;
            min-height: 26px;
            line-height: 20px;
            padding:3px 27px 3px 30px;
            display: flex;
            align-items: center;
        }
        .nochile-cate {
            font-size: 14px;
            min-height: 36px;
            line-height: 21px;
            padding-left: 15px;
            display: flex;
            align-items: center;
            padding: 3px 28px 3px 15px;
        }
        .cate-flex {
            padding-top: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            min-height: 42px;
            line-height: 21px;
            padding-left: 15px;
            align-items: center;
            span {
                width: 80%;
                padding: 4px 0;
            }
            .icon-down {
                width: 16%;
                text-align: right;
                padding-right: 10px;
            }
        }
    }
    .ch-route-lv-item-box {
        box-sizing: border-box;

        .ch-route-lv-item {
            padding-left: 13px;
        }

        .ch-route-lv-item-flex {
            .ch-route-lv-item-icon {
                margin-top: 13px;
                margin-bottom: 13px;
                margin-right: 12px;
                font-size: 16px;
                fill: rgba(84, 92, 177, 1);
            }

            .ch-route-lv-item-icon-active {
                margin-top: 13px;
                margin-bottom: 13px;
                margin-right: 12px;
                font-size: 16px;
                line-height: 16px;
                fill: rgba(204, 208, 255, 1);
            }

            .ch-route-lv-item-text {
                margin-top: 14px;
                margin-bottom: 14px;
                font-size: 12px;
                font-weight: 400;
            }

            .ch-route-lv-item-text-active {
                margin-top: 13px;
                margin-bottom: 13px;
                font-size: 14px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
            }

            .inactive-icon {
                color: #2e357f;
            }
            .active-icon {
                color: #ccd0ff;
            }
        }

        display: block;
        color: #999999;
        line-height: 42px;
        height: 42px;
        width: 100%;
    }

    .active {
        color: #ffffff;
        background: #0062ff;
    }
}

.container {
    background: #f3f3f5;
    height: calc(100% - 80px);
}

.ch-hidden-nav {
    line-height: 36px;
    text-align: right;
    padding-right: 13px;
}

.ch-hidden-nav-h {
    line-height: 36px;
    text-align: right;
    padding-right: 28px;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}

.dropdown-tab-text {
    font-size: 14px;
}
</style>
